import React from 'react';

import { PostType } from './PostType';
import { SectionType } from './SectionType';

export type PostsListType = {
  postsList: PostType[];
  sectionsList: SectionType[];
  handleClick: (e: React.MouseEvent<HTMLDivElement>, url: string) => void;
};
